var t = require('i18n').t

module.exports = require('ember-super-field').types.Model.extend({
    modelClass: Billy.CountryGroup,

    sortProperty: 'name',

    noOptionsFoundText: t('ui.fields.superfield.no_country_groups_found')
})
